<div>
  <ng-container *ngIf="!isAddingManually">
    <div class="license-searcher-container">
      <div class="license-searcer-input">
        <p class="label-text" for="pickupDate">{{ 'licensePlate' | translate }}</p>
        <input class="form-text-input" [ngClass]="{ 'error-color': searchError }" type="text" [(ngModel)]="licensePlate"
          placeholder="1234JMS o 1234 JMS" autocomplete="on" (keyup.enter)="handleEnter($event)" />
      </div>
      <button class="button-green button-padding-11 search-button" (click)="searchByLicensePlate()">{{ 'search' |
        translate }}</button>
    </div>
    <div class="toggle-option-blue" (click)="toggleForm()">
      {{'addVehicleManually' | translate}}
    </div>
    <div *ngIf="VehicleData && ShowVehicleCard && VehicleData.licensePlate?.[0]" class="vehicle-info-card">
      <h4 *ngIf="ShowVehicleTitle">{{ 'yourVehicle' | translate }}</h4>
      <div class="vehicle-info">
        <img *ngIf="chassisType[VehicleData.chassisTypeId]?.icon" [src]="chassisType[VehicleData.chassisTypeId].icon"
          alt="Car" class="vehicle-img" />
        <div class="vehicle-info_data">
          <p class="car-title">{{ VehicleData.brand }} - {{ VehicleData.model }}</p>
          <p class="car-specs">
            {{ VehicleData.licensePlate }} ·
            {{ VehicleData.fuelType }} ·
            {{ VehicleData.chassisType }}
          </p>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="isAddingManually">
    <form [formGroup]="VehicleForm">
      <div class="form-row" style="margin-top: 0px;">
        <label class="label-text" for="licensePlate">{{ 'licensePlate' | translate }}</label>
        <input class="form-text-input" type="text" id="licensePlate" formControlName="licensePlate"
          placeholder="1234JMS o 1234 JMS" [ngClass]="{
              error: VehicleForm.get('licensePlate')?.invalid && VehicleForm.invalid
            }" />
        <!-- <div *ngIf="VehicleForm.get('licensePlate')?.invalid && VehicleForm.invalid" class="error">
            {{ 'required' | translate }}
          </div> -->
      </div>
      <div class="form-row-two">
        <div class="form-col">
          <label class="label-text" for="brand">{{ 'brand' | translate }}</label>
          <input class="form-text-input" type="text" id="brand" formControlName="brand" placeholder="Fiat"
            [ngClass]="{ error: VehicleForm.get('brand')?.invalid && VehicleForm.invalid }" />

          <!-- <div *ngIf="VehicleForm.get('brand')?.invalid && VehicleForm.invalid" class="error">
            {{ 'required' | translate }}
          </div> -->

        </div>
        <div class="form-col">
          <label class="label-text" for="model">{{ 'model' | translate }}</label>
          <input class="form-text-input" type="text" id="model" formControlName="model" placeholder="Panda"
            [ngClass]="{ error: VehicleForm.get('model')?.invalid && VehicleForm.invalid }" />

          <!-- <div *ngIf="VehicleForm.get('model')?.invalid && VehicleForm.invalid" class="error">
            {{ 'required' | translate }}
          </div> -->

        </div>
      </div>
      <div class="form-row-two">
        <div class="form-col">
          <label class="label-text" for="chassisType">{{ 'vehicleType' | translate }}</label>
          <!-- <div class="select-container">
            <div class="custom-select" (click)="toggleSelect('chassisType')"
              (keydown)="handleKeydown($event, 'chassisType')" tabindex="0" role="combobox"
              [attr.aria-expanded]="isOpen['chassisType']" [attr.aria-controls]="'chassis-type-options'">
              <div class="selected-option">
                {{ getSelectedOptionText('chassisType') }}
              </div>
              <div class="chevron" [class.open]="isOpen['chassisType']"></div>
            </div>
            <div class="options-container" *ngIf="isOpen['chassisType']" id="chassis-type-options" role="listbox">
              <div class="options-scroll">
                <div class="option" *ngFor="let vehicle of vehicles; let i = index"
                  [class.selected]="vehicle === form.get('chassisType')?.value"
                  (click)="selectOption('chassisType', vehicle)"
                  (keydown)="handleOptionKeydown($event, 'chassisType', vehicle)" tabindex="0" role="option"
                  [attr.aria-selected]="vehicle === form.get('chassisType')?.value"
                  [attr.id]="'chassis-type-option-' + i">
                  {{ vehicle }}
                </div>
              </div>
            </div>
          </div> -->

          <app-select-by-keys-dropdown [style.width]="'100%'" [dataArray]="chassisTypeIdArray"
            [translateKey]="'CHASSIS_TYPE_ENUM.'" [selectedKey]="VehicleForm.value.chassisTypeId"
            [placeholder]="'Selecciona'" (optionEmitter)="chassisTypeChange($event)"></app-select-by-keys-dropdown>

          <!-- <div *ngIf="VehicleForm.get('chassisType')?.invalid && VehicleForm.invalid" class="error">
            {{ 'required' | translate }}
          </div> -->
        </div>
        <div class="form-col">
          <label class="label-text" for="fuelType">{{ 'fuelType' | translate }}</label>
          <!-- <div class="select-container">
            <div class="custom-select" (click)="toggleSelect('fuelType')" (keydown)="handleKeydown($event, 'fuelType')"
              tabindex="0" role="combobox" [attr.aria-expanded]="isOpen['fuelType']"
              [attr.aria-controls]="'fuel-type-options'">
              <div class="selected-option">
                {{ getSelectedOptionText('fuelType') }}
              </div>
              <div class="chevron" [class.open]="isOpen['fuelType']"></div>
            </div>
            <div class="options-container" *ngIf="isOpen['fuelType']" id="fuel-type-options" role="listbox">
              <div class="option" *ngFor="let fuelType of fuelTypes; let i = index" [class.selected]="
                  fuelType.fuelTypeId === form.get('fuelType')?.value?.fuelTypeId
                " (click)="selectOption('fuelType', fuelType)"
                (keydown)="handleOptionKeydown($event, 'fuelType', fuelType)" tabindex="0" role="option"
                [attr.aria-selected]="
                  fuelType.fuelTypeId === form.get('fuelType')?.value?.fuelTypeId
                " [attr.id]="'fuel-type-option-' + i">
                {{ fuelType.fuelTypeDescription }}
              </div>
            </div>
          </div> -->

          <app-select-by-keys-dropdown [style.width]="'100%'" [dataArray]="FuelTypeEnumArray"
            [translateKey]="'FUEL_TYPE_ENUM.'" [selectedKey]="VehicleForm.value.fuelTypeId" [placeholder]="'Selecciona'"
            (optionEmitter)="fuelTypeChange($event)"></app-select-by-keys-dropdown>
          <!-- 
          <div *ngIf="VehicleForm.get('fuelType')?.invalid && VehicleForm.invalid" class="error">
            {{ 'required' | translate }}
          </div> -->
        </div>
      </div>
    </form>
    <div class="toggle-option-blue" (click)="toggleForm()">
      Añadir vehículo por matricula
    </div>
  </ng-container>
</div>